<template>
  <a-config-provider :locale="locale">
    <div id="app" :class="classObj">
      <router-view :key="this.$route.path" />
    </div>
  </a-config-provider>
</template>

<script>
import antdEnCN from 'ant-design-vue/es/locale-provider/zh_CN'

export default {
  data() {
    return {
      classObj: {
        sidebarHidden: window.self !== window.top || window.__MICRO_APP_ENVIRONMENT__ // 被嵌入或者是微前端环境下=>隐藏菜单
      }
    }
  },
  computed: {
    userName() {
      const STORAGE = localStorage.getItem('user')
      if (!STORAGE) return '鱼爪网'

      const USER = JSON.parse(localStorage.getItem('user'))
      return `${USER.name} ${USER.job_number}`
    },
    locale() {
      return antdEnCN
    }
  },
  created() {
    // this.$nextTick(() => {
    //   digitalWaterMark && digitalWaterMark.render({ UUID: this.userName, zIndex: 1000000, density: 0.81 })
    // })
  }
}
</script>

<style lang="less">
.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.169) !important;
}

.ant-pro-sider-menu-sider {
  z-index: 1000001 !important;
}

.tox-fullscreen .tox.tox-tinymce.tox-fullscreen {
  z-index: 1000002 !important;
}

.sidebarHidden {
  .ant-layout-sider,
  .ant-layout-header,
  .ant-breadcrumb {
    display: none;
  }
  .ant-layout {
    padding-left: 0 !important;
  }
}
</style>
